const IDGenerator = (suffix = "") => {
  //? This id, while very safe in the sense that you are not going to see any duplicates, may be too verbose. Maybe remove the math.random() if that's the case
  return `${suffix}-${Date.now()}-${Math.random()}`
}

export default IDGenerator